import React, { useEffect } from "react";
import { Line, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import "./Dashboard.css";
import { Link } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const Dashboard = () => {
  const lineData = {
    labels: ["12:25", "12:30", "12:35", "12:40"],
    datasets: [
      {
        label: "Active Conversations",
        data: [2, 1, 1, 1],
        borderColor: "#4e73df",
        backgroundColor: "rgba(78, 115, 223, 0.2)",
      },
    ],
  };

  const messageCountData = {
    labels: ["12:21-12:27", "12:27-12:32", "12:32-12:37", "12:37-12:42"],
    datasets: [
      {
        label: "Message Count",
        data: [0, 5, 15, 3],
        borderColor: "#6f42c1",
        backgroundColor: "rgba(111, 66, 193, 0.2)",
      },
    ],
  };

  const doughnutData = {
    labels: ["Received", "Sent by bot"],
    datasets: [
      {
        data: [65, 35],
        backgroundColor: ["#6610f2", "#6f42c1"],
        borderWidth: 0,
      },
    ],
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("my-body-class");
    return () => {
      document.body.classList.remove("my-body-class");
    };
  }, []);

  return (
    <div className="dashboard-container">
      {/* Header */}
      {/* <header className="dashboard-header">
        <h1>Overview</h1>
      </header> */}

      {/* Cards */}
      <div className="metrics-container">
        <div className="metric-card">
          <p>
            Conversations Last Minute: <strong>1</strong>
          </p>
        </div>
        <div className="metric-card">
          <p>
            Conversations Last Hour: <strong>2</strong>
          </p>
        </div>
        <div className="metric-card">
          <p>
            Messages/Conversation: <strong>7.68</strong>
          </p>
        </div>
        {/* <div className="metric-card">Conversation Length: <strong>57:42</strong></div>
        <div className="metric-card">Messages Sent-Received: <strong>23</strong></div> */}
      </div>

      {/* Buttons */}
      <div className="button-group text-right">
        <Link to="/add-intent" className="btn btn-primary">
          Add Intents{" "}
        </Link>
        <Link to="/view-intent" className="btn btn-primary">
          View Intents{" "}
        </Link>
        <Link to="/bot-manage" className="btn btn-primary">
          View Chat Log
        </Link>
      </div>

      {/* Graphs */}
      <div className="graphs-container">
        <div className="graph-card">
          <h3>Active Conversations</h3>
          <Line data={lineData} />
        </div>
        <div className="graph-card">
          <h3>Message Count</h3>
          <Line data={messageCountData} />
        </div>
        <div className="graph-card">
          <h3>Message Direction</h3>
          <div className="docugnut-section">
            <Doughnut data={doughnutData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
